import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { tabPanel } from '../_interfaces/icontrols-common/tabview.interface';
import { BaseComponent } from '../_common/dx-base-component';

@Component({
    selector: 'dx-tabview',
    templateUrl: './tabview.component.html',
    styleUrls: ['./tabview.component.scss'],
    standalone: false
})
export class TabViewComponent extends BaseComponent {
    @Input() tabPanels!: tabPanel[];
    @Input() activeIndex: number = 0;
    @Output() onTabClose = new EventEmitter();
    @Output() tabChange = new EventEmitter();
    override ngOnInit() {
        super.ngOnInit();
        this.componentName = 'TabViewComponent';
    }
    onTabClick(e:any){
        this.onTabClose.emit(e);
    }
    onTabChange(e:any){
      this.tabChange.emit(e);
    }
}
